var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "button-area form-group" }, [
    _vm.showSaveButton
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary btn-save",
            class: { disabled: !_vm.isValidForm },
            attrs: { type: "submit" },
            on: {
              click: function($event) {
                return _vm.$emit("save")
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-save" }),
            _vm._v(
              _vm._s(
                _vm.resource("JourneyBuilder_Index_SaveButton_DisplayText")
              ) + "\n    "
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showUnlockButton
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary btn-unlock",
            class: { disabled: !_vm.isValidForm },
            attrs: { type: "submit" },
            on: {
              click: function($event) {
                return _vm.$emit("unlock")
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-lock" }),
            _vm._v(
              _vm._s(
                _vm.resource("JourneyBuilder_Shared_UnlockButton_DisplayText")
              ) + "\n    "
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showCloneButton
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary ml-2",
            on: {
              click: function($event) {
                return _vm.$emit("clone")
              }
            }
          },
          [
            _c("i", { staticClass: "fas fa-clone" }),
            _vm._v(
              " " +
                _vm._s(
                  _vm.resource("JourneyBuilder_Shared_CloneButton_DisplayText")
                ) +
                "\n    "
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }